// extracted by mini-css-extract-plugin
module.exports = {"terms":"terms_terms__pCnl8"};